import type { Blank } from 'store/types/common';

import { PERFORMANCE_RATING, SATISFACTION_RATING } from '../../constants';

import { ReactComponent as BadLine } from 'assets/icons/bad-line.svg';
import { ReactComponent as NeutralFace } from 'assets/icons/face-neutral.svg';
import { ReactComponent as SadFace } from 'assets/icons/face-sad.svg';
import { ReactComponent as SmileFace } from 'assets/icons/face-smile.svg';
//TODO оптимизировать импорт картинок
import { ReactComponent as GoodLine } from 'assets/icons/good-line.svg';
import { ReactComponent as NeutralLine } from 'assets/icons/neutral-line.svg';

import styles from './styles.module.scss';

interface ClientBlankEstimateScheduleProps {
	data: Blank;
}

export const ClientBlankEstimateSchedule = ({ data }: ClientBlankEstimateScheduleProps) => {
	const changeExecution = data.changeExecution;

	const changeSatisfaction = data.changeSatisfaction;

	console.log(data.changeSatisfaction);

	const valueChart = (value: number | undefined) => {
		if (value == null) {
			return '-';
		}

		if (value > 0) {
			return (
				<>
					<GoodLine />
					<SmileFace />
					<span>{value}</span>
				</>
			);
		} else if (value === 0 || value === 1) {
			return (
				<>
					<NeutralLine />
					<NeutralFace />
					<span>{value}</span>
				</>
			);
		} else if (value < 0) {
			return (
				<>
					<BadLine />
					<SadFace />
					<span>{value}</span>
				</>
			);
		}
	};

	return (
		<div className={styles.chart}>
			<div className={styles.chart__block}>
				<p>{PERFORMANCE_RATING}</p>
				<div className={styles.chart__data}>{valueChart(changeExecution)}</div>
			</div>
			<div className={styles.chart__block}>
				<p>{SATISFACTION_RATING}</p>
				<div className={styles.chart__data}>{valueChart(changeSatisfaction)}</div>
			</div>
		</div>
	);
};
